import axios from 'axios';
import { config } from 'config';
import i18n from 'i18nextInstance';
const https = require('https');
const {
    allowHTTP,
    apiUrl,
    availableLanguages,
    db,
    defaultLanguage
} = config;

const instance = axios.create({
    baseURL: apiUrl,
    httpsAgent: new https.Agent({
        rejectUnauthorized: !allowHTTP
    })
});

instance.interceptors.request.use(config => {
    const getLanguage = () => {
        if (!i18n.language) return defaultLanguage;
        const selectedLanguage = i18n.language.slice(0, 2);
        return availableLanguages.includes(selectedLanguage) ? selectedLanguage : defaultLanguage;
    };
    config.headers.Authorization = config?.headers?.Authorization ?? `Bearer ${ JSON.parse(localStorage.getItem('sessionData')) ? JSON.parse(localStorage.getItem('sessionData')).token : '' }`;
    config.headers.Language = getLanguage();
    if (db) {
        config.headers.Database = db;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    console.error(error);
    const { response: { status } = {} } = error;
    if ([400, 401].includes(status)) {
        localStorage.removeItem('sessionData');
    }
    throw error;
});

export default instance;
